 import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
import React, { useEffect } from 'react';
const MediaGallery = () => {
    useEffect(() => {
        document.title = 'Media Gallery -  St. Francis Xavier School';  
    }, []);  
    
  return (
      <>
      <Header/>
      <div className="innerslide">
      <ul className="breadcrumb">
          <li><Link to="/"> Home</Link> </li> 
          <li>  Gallery</li>
           <li>Media Gallery </li>
      </ul>
  </div> 
  <section className="innerbody media_sec">
  <div className='container'>
        <div className='row'>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_45.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_45.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules"> Inter House Sports Competition </h4> 
            <p><strong>Published On :</strong>10th Nov, 2025 </p>
        </article>
    </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_44.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_44.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules"> Inter House Sports Competition </h4> 
            <p><strong>Published On :</strong>10th Nov, 2025 </p>
        </article>
    </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_43.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_43.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules"> Inter House Sports Competition </h4> 
            <p><strong>Published On :</strong>10th Nov, 2025 </p>
        </article>
    </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_42.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_42.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules"> Inter House Sports Competition </h4> 
            <p><strong>Published On :</strong>10th Nov, 2025 </p>
        </article>
    </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_41.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_41.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules"> Inter House Sports Competition </h4> 
            <p><strong>Published On :</strong>10th Nov, 2025 </p>
        </article>
    </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_40.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_40.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules"> Inter House Sports Competition </h4> 
            <p><strong>Published On :</strong>10th Nov, 2025 </p>
        </article>
    </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_39.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_39.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Newspaper : </strong>Panch Baje, Nab Chor, Denika Bhaskar & Denik Jagran </p>
            <p><strong>Published On :</strong>22nd Dec, 2024</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_38.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_38.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a> 
            </center>
            <p><strong>Newspaper : </strong> Nabh Choar </p>
            <p><strong>Published On :</strong>15th May, 2024</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_37.jpeg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_37.jpeg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Newspaper : </strong> Denik Jagran </p>
            <p><strong>Published On :</strong>16th May, 2024</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_36.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_36.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Newspaper : </strong> Dainik Bhaskar </p>
            <p><strong>Published On :</strong>16th May, 2024</p>
        </article>
    </div>
    
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_28.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_28.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_29.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_29.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_30.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_30.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_31.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_31.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_32.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_32.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_33.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_33.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_34.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_34.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_35.jpg">
                    <LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_35.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <p><strong>Published On :</strong>7th May, 2024</p>
            <p><strong>&nbsp;</strong></p>
        </article>
    </div>
    
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_27.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_27.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules">Olympiad </h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar </p>
            <p><strong>Published On :</strong>21th April 2024</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_26.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_26.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules">Olympiad </h4>
            <p><strong>Newspaper : </strong> Denik Jagran </p>
            <p><strong>Published On :</strong>21th April 2024</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_25.jpeg"><LazyLoad>
                        <img
                       src="https://webapi.entab.info/api/image/SFXH/public/images/Media_25.jpeg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules">Traffic Rules </h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar </p>
            <p><strong>Published On :</strong>4th April 2024</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_24.jpeg"><LazyLoad>
                        <img
                       src="https://webapi.entab.info/api/image/SFXH/public/images/Media_24.jpeg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Traffic Rules">Traffic Rules </h4>
            <p><strong>Newspaper : </strong> Denik Jagran </p>
            <p><strong>Published On :</strong> 4th April 2024</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_23.jpeg"><LazyLoad>
                        <img
                       src="https://webapi.entab.info/api/image/SFXH/public/images/Media_23.jpeg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">Sports Day </h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar </p>
            <p><strong>Published On :</strong> 30th Nov 2023</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_22.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_22.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Dance Competition">Dance Competition </h4>
            <p><strong>Newspaper : </strong> Dainik Jagran </p>
            <p><strong>Published On :</strong> 30th Oct 2023</p>
        </article>
    </div>
    
    
    
    
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_21.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_21.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Dance Competition">Dance Competition </h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar </p>
            <p><strong>Published On :</strong> 30th Oct 2023</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_20.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_20.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="सामान्य ज्ञान प्रतियोगिता">सामान्य ज्ञान प्रतियोगिता </h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar </p>
            <p><strong>Published On :</strong> 29th Oct 2023 </p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_19.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_19.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">राज्य स्तरीय विद्यालय खेलखुद </h4>
            <p><strong>Newspaper : </strong> नभ छोर </p>
            <p><strong>Published On :</strong> 21st Sep 2023</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_18.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_18.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">राज्य स्तरीय विद्यालय खेलखुद </h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar - Hissar</p>
            <p><strong>Published On :</strong> 21st Sep 2023</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_17.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_17.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">CBSE Results</h4>
            <p><strong>Newspaper : </strong> Hissar Today</p>
            <p><strong>Published On :</strong> 19th May 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_16.jpeg"><LazyLoad>
                        <img
                       src="https://webapi.entab.info/api/image/SFXH/public/images/Media_16.jpeg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">Annual Function</h4>
            <p><strong>Newspaper : </strong> Hissar Today</p>
            <p><strong>Published On :</strong> 12th Nov 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_15.jpeg"><LazyLoad>
                        <img
                       src="https://webapi.entab.info/api/image/SFXH/public/images/Media_15.jpeg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">School Topper</h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar - Hissar</p>
            <p><strong>Published On :</strong> 28th Jul, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_14.jpeg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_14.jpeg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">School Toppers</h4>
            <p><strong>Newspaper : </strong> Dainik Bhaskar - Hissar</p>
            <p><strong>Published On :</strong> 28th Jul, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_13.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_13.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">Sports Day Celebration</h4>
            <p><strong>Newspaper :</strong> Hissar Today</p>
            <p><strong>Published On :</strong> 14th May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_12.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_12.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">Sports Day Celebration</h4>
            <p><strong>Newspaper :</strong> Hissar Today</p>
            <p><strong>Published On :</strong> 14th May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_11.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_11.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">Sports Day Celebration</h4>
            <p><strong>Newspaper :</strong> Hissar Today</p>
            <p><strong>Published On :</strong> 14th May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_10.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_10.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sports Day Celebration">Sports Day Celebration</h4>
            <p><strong>Newspaper :</strong> Hissar Today</p>
            <p><strong>Published On :</strong> 14th May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_9.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_9.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Winners of CBSE">Winners of CBSE</h4>
            <p><strong>Newspaper :</strong> Hissar Newspaper</p>
            <p><strong>Published On :</strong> 4th May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_8.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_8.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Welcome Day in School">Welcome Day in School</h4>
            <p><strong>Newspaper :</strong> Hansi Kranti News Hisar</p>
            <p><strong>Published On :</strong> 4th May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_7.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_7.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Welcome Day in School">Welcome Day in School</h4>
            <p><strong>Newspaper :</strong> Chirag Times News</p>
            <p><strong>Published On :</strong> 1st May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_6.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_6.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Welcome Day in School">Welcome Day in School</h4>
            <p><strong>Newspaper :</strong> Hansi Kranti News Hisar</p>
            <p><strong>Published On :</strong> 1st May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_5.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_5.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Welcome Day in School">Welcome Day in School</h4>
            <p><strong>Newspaper :</strong> Sar Samachar</p>
            <p><strong>Published On :</strong> 1st May, 2022</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_1.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_1.jpg"
                        alt="sfxhisar" className="img-fluid"/></LazyLoad>
                </a>
            </center>
            <h4 title="Winners of CBSE">Winners of CBSE</h4>
            <p><strong>Newspaper :</strong> Dainik Bhaskar</p>
            <p><strong>Published On :</strong> 5th May, 2019</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_2.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_2.jpg"
                        alt="sfxhisar"/></LazyLoad>
                </a>
            </center>
            <h4 title="CBSE National Handball Competition">CBSE National Handball Competition</h4>
            <p><strong>Newspaper :</strong> Nabh Chor</p>
            <p><strong>Published On :</strong> 23rd Nov, 2018</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_3.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_3.jpg"
                        alt="sfxhisar"/></LazyLoad>
                </a>
            </center>
            <h4 title="Inter School English Declamation Competition">Inter School English Declamation
                Competition</h4>
            <p><strong>Newspaper :</strong> Hisar</p>
            <p><strong>Published On :</strong> 24th Nov, 2018</p>
        </article>
    </div>
    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <article>
            <center>
                <a data-magnify="gallery" data-src="" data-group="building"
                    href="https://webapi.entab.info/api/image/SFXH/public/images/Media_4.jpg"><LazyLoad>
                        <img src="https://webapi.entab.info/api/image/SFXH/public/images/Media_4.jpg"
                        alt="sfxhisar"/></LazyLoad>
                </a>
            </center>
            <h4 title="Sahodya Inter School Science Exhibition">Sahodya Inter School Science Exhibition</h4>
            <p><strong>Newspaper :</strong> Nabh Chor </p>
            <p><strong>Published On :</strong> 27th Oct, 2018</p>
        </article>
    </div>
        </div>
   </div> 
</section>
<Footer/>
      </>
  )
}

export default MediaGallery
